<template>
	<div id="partner">
    <div class="top">
    	<div>已练习：<span class="red">{{ count }}</span>次</div>
		<a class="btn-end" @click="endScene">结束练习</a>
    </div>
    <div class="hawkeye">
    	<div class="left">
    		<div class="iframe-box">
					<iframe src="/customer/action/workbench/index" width="100%" height="100%" frameborder="0"></iframe>
  			</div>
    	</div>
    	<div class="right" v-if="selfassessment==false">
    		<div class="header">练习得分</div>
    		<div class="content">
    			<!--评分结果-->
    			<div class="video">
    				<span>练习录音</span>
						<audio :src="videoUrl" controls="controls"></audio>
					</div>
    			<template v-if="gradeState == 1">
						<p>点评自己的练习</p>
						<div class="box otherbox">
							<template v-for="(f, index) in gradeList">
								<!-- <p class="name">{{ f.name }}</p> -->
								<template v-for="(s, key) in f.childList">

									<div class="topicformat">
										<div class="second name SpecialSymbol"><span>*</span>{{ s.name }}</div>
									<div class="SpecialSymboltext">
										<p class="second " v-for="(t, tkey) in s.childList">
										<el-radio v-model="s.checked" :label="t.id">{{ t.name }}</el-radio>
									</p>
									</div>
									</div>
								</template>
							</template>
						</div>
						<div class="save"><a @click="saveScore">确认自评</a></div>
    			</template>
    			<template v-else-if="gradeState == 2">

					<!-- 原来的表单 -->
						<!-- <div class="table">
                            <div class="title">
                                <span>练习评分</span>
                                <span class="blue">{{ gradeScore }}分</span>
                            </div>
                            <el-table :data="afterArry" :span-method="objectSpanMethod" border style="width: 100%;" :header-cell-class-name="addClass">
                          <el-table-column prop="parentname" label="练习内容" width="80" align="center"></el-table-column>
                          <el-table-column prop="name" label="二级内容" width="80" align="center"></el-table-column>
                          <el-table-column label="自评" align="center">
                            <template slot-scope="scope">
                                        {{ scope.row.selfDp }}
                            </template>
                          </el-table-column>
                          <el-table-column prop="score" label="得分" width="50" align="center"></el-table-column>
                          <el-table-column label="建议" align="center">
                            <template slot-scope="scope">
                                    <font color="red">
                                      {{ scope.row.description }}
                                     </font>
                            </template>
                          </el-table-column>
                        </el-table>
                        </div> -->


						<!-- 现在的表单 -->
					
	    		</template>
	    		<template v-else>
	    			<div class="init">
		  				<!--初始化-->
		    			<p><img src="@/assets/images/voiceScene/icon_kong.png" /></p>
		    			<p>完成本次练习后</p>
		    			<p>才能给自己打分哦</p>
		    		</div>
	  			</template>
    		</div>
    	</div>
		<!-- 表单 -->
		<div v-else>
		<div v-if="complete=='yes'">
            <div class="bottom">
  		       <div class="content">
					  <!--评分结果-->
						<h3>{{existAdvise ? '练习得分与建议' : '练习得分'}}</h3>
		  			<!-- <audio :src="videoUrl" controls="controls"></audio> -->
					  <div class="video ivideo">
    				<span>练习录音</span>
						<audio :src="videoUrl" controls="controls"></audio>
					</div>
						<!-- <h3>练习评分({{gradeScore}})</h3> -->
						<el-table :data="gradeList2" :span-method="objectSpanMethod" :header-cell-style="rowClass" border style="width: 100%;">
				      <el-table-column  label="练习内容"  align="center" >
					  <el-table-column prop="parentname" width="110" align="center"></el-table-column>
					  <el-table-column prop="name" width="150" align="center"></el-table-column>
									  	 
					  </el-table-column>
				      <!-- <el-table-column prop="name" label="二级内容" width="150" align="center"></el-table-column> -->
					    <el-table-column prop="gradeScore" label="总分" width="80" align="center">
							
						</el-table-column>
				      <el-table-column label="自评分" align="center">
						    <el-table-column  label="扣分"  align="center" width="auto">
								<template slot-scope="scope">
									<el-tooltip placement="top">
									  <div class="text-style">
                                         <span class="DeductPoints" v-if="scope.row.gradeScore-scope.row.score!=0">-{{scope.row.gradeScore-scope.row.score}}</span>
						                 <span class="DeductionDetails">({{scope.row.checkedName}})</span>
						            </div>
									
                                     <div slot="content">{{scope.row.checkedName}}</div>

                                   </el-tooltip>
                              <!-- {{ scope.row.score-scope.row.gradeScore}} -->
                             
                    </template>
							</el-table-column>
                <el-table-column  prop="score" label="得分" width="80" align="center" >
					
				</el-table-column>
             

				      </el-table-column>
					    <!-- <el-table-column prop="checkedName" label="点评"  align="center"></el-table-column> -->
					    <el-table-column v-if="existAdvise" label="练习建议" align="center">
							
							 <template slot-scope="scope">
								 
									<span class="isred">{{ scope.row.description }}</span>
                              <!-- {{ scope.row.score-scope.row.gradeScore}} -->
                             
                    </template>
				      <!-- <el-table-column v-if="existAdvise" label="系统建议" align="center">
				          <el-table-column label="建议" align="center">
				           
                            <font c <template slot-scope="scope">olor="red">
                              {{ scope.row.description }}
                             </font>
                    </template>
				          </el-table-column> -->
                </el-table-column>
				    </el-table>
  		       </div>
  	       </div>
		</div>
		</div>
    </div>
    <div class="confirmbox-bg" v-if="gradeState == 1"></div>
    <div class="confirmbox" v-if="gradeState == 1">
    	<div class="head">
    		<span class="tip">提示</span>
    	</div>
    	<div class="text">
    		<p><img src="@/assets/images/voiceScene/icon_tips.png" /></p>
    		<p>请先完成自评~</p>
    	</div>
    </div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				id: '',
				count: 0,
				callId: '',
				videoUrl: '', //录音文件
				gradeState: null, //评分状态
				gradeScore: '', //得分
				gradeList: '', //点评内容
				gradeList2: '', //点评内容
				evaluateList: [], //练习建议
				teacherGradeList: [], //老师打分
				afterArry: [], //表格数据
				spanArr: [],
				pos: 0,
				keyData: 0 ,//更新页面
				selfassessment:false, //判断是否自评（表单显现）
				gradeScore1:'',//表单练习得分
				complete:'no', //是否点击提交自评
				existAdvise : false ,//是否显示 系统建议
			}
		},
		watch: {

		},
		created() {
			window.getCallId = this.getCallId;
		},
		mounted() {
			this.queryExerciseCount();
			this.queryCallNoSelfValuate();
			
		},
		methods: {
			// 合并表头
  rowClass({ row, column,rowIndex,columnIndex}) {
        if(rowIndex===0 && columnIndex===0) {
          this.$nextTick(()=> {
            if(document.getElementsByClassName(column.id).length!==0) {
              document.getElementsByClassName(column.id)[0].setAttribute('rowSpan',2);
              return false
            }
          })
        }
        if(rowIndex===1 && (columnIndex===0 || columnIndex===1)) {
          return {display:'none'}
        }

      },
			//提交查询
			uploadqueryGrade(id) {
				let self = this;
				let data = {
					'id': id
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryDetail', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.gradeScore1 = result.data.gradeScore;
						this.gradeList2 = [];
						const teacherGradeMap = new Map();
						if(result.data.teacherGradeList != null) {
							result.data.teacherGradeList.map((item) => {
						item.childList.map((obj) => {
						let checkedId = '';
						let checkedName = '';
						obj.childList.map((o) => {
							if(o.checked) {
							checkedId = o.id;
							}
						})

						let tempObj = {
							'score': obj.gradeScore,
							'childList': obj.childList,
							'checkedId': checkedId
						}
						teacherGradeMap.set(obj.id, tempObj);
							})
						})
			}else if(result.data.gradeList != null){
              result.data.gradeList.map((item) => {
                item.childList.map((obj) => {
                  let checkedId = '';
                  let checkedName = '';
                  let tempObj = {
                    'childList': obj.childList,
                    'checkedId': checkedId
                  }
                  teacherGradeMap.set(obj.id, tempObj);
                })
              })

						}
						if(result.data.gradeList != null) {
							result.data.gradeList.map((item) => {
								item.childList.map((obj) => {
									let checkedId = '';
									let checkedName = '';
									let description = '';
									obj.childList.map((o) => {
										if(o.checked) {
											checkedId = o.id;
											checkedName = o.name;
											description = o.description;
										}
									})
									let teacherGradeObj = teacherGradeMap.get(obj.id);
									let tempObj = {
										'parentname': item.name,
										'name': obj.name,
										'score': obj.gradeScore,
										'gradeScore':obj.score,
										'childList': obj.childList,
										'checkedId': checkedId,
										'checkedName': checkedName,
										'description': description,
										'teacherGrade': teacherGradeObj ? teacherGradeObj : {}
									}
									self.gradeList2.push(tempObj);
                                    //判断是否有建议，无建议，则不显示“系统建议”那一列
                                    if(this.existAdvise == false && description/* != null && description.trim() != ''*/){
                                        this.existAdvise = true;
                                    }
								})
							})
						}
						this.getSpanArr(this.gradeList2);
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},

			//接收callId
			getCallId(id) {
				console.log('传进来的callId------'+id)
				this.callId = id;
				this.queryGrade();
			},
			//查询对练次数
			queryExerciseCount() {
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/queryPartnerExerciseCount').then(response=>{
					var result = response.data;
					if(result.success) {
						this.count = result.data;
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//查询是否存在未自评数据
			queryCallNoSelfValuate() {
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/queryCallNoSelfValuate?type=Each').then(response=>{
					var result = response.data;
					if(result.success) {
						if(result.data != null) {
							this.id = result.data.id;
    						this.videoUrl = result.data.videoUrl;
    						this.gradeState = result.data.gradeState;
    						this.gradeScore = result.data.gradeScore;
    						this.evaluateList = result.data.evaluateList;
    						this.gradeList = result.data.gradeList;
    						this.teacherGradeList = result.data.teacherGradeList;
								console.log(this.gradeList,5555)
    						if(this.gradeList != null) {
    							this.gradeList.map((item) => {
    								item.childList.map((obj) => {
    									obj.isClickSecond = false;
    								})
    							})
    						}
    						this.afterArry = [];
    						//if(result.data.teacherGradeList != null) {
    							for(let i=0;i<this.gradeList.length;i++) {
    								for(let c=0;c<this.gradeList[i].childList.length;c++) {
    									for(let ic=0;ic<this.gradeList[i].childList[c].childList.length;ic++) {
    										let selfDp = '',
    												teacherDp = '';
    										if(this.gradeList[i].childList[c].childList[ic].checked) {
    											selfDp = this.gradeList[i].childList[c].childList[ic].name;
    											//for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
    												//if(this.teacherGradeList[i].childList[c].childList[j].checked) {
    													//teacherDp = this.gradeList[i].childList[c].childList[j].name;
    													//break;
    												//}
    											//}
    											let tempObj = {
    												'parentname': this.gradeList[i].name,
    												'name': this.gradeList[i].childList[c].name,
    												'score': this.gradeList[i].childList[c].gradeScore,
    												'selfDp': selfDp,
    												'teacherDp': teacherDp,
    												'description': this.gradeList[i].childList[c].childList[ic].description,
    												'teacherScore': null//this.teacherGradeList[i].childList[c].gradeScore
    											}
    											this.afterArry.push(tempObj);
												console.log(this.gradeList[i].childList[c],85474)
    											break;
    										}
    									}
    								}
    							}
    							this.getSpanArr(this.afterArry);
    						//}
						}
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//查询评分结果
			queryGrade() {
				let self = this;
				let data = {
					'callId': this.callId
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/queryPartnerGrade', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.id = result.data.id;
						this.videoUrl = result.data.videoUrl;
						this.gradeState = result.data.gradeState;
						this.gradeScore = result.data.gradeScore;
						this.evaluateList = result.data.evaluateList;
						this.gradeList = result.data.gradeList;
						this.teacherGradeList = result.data.teacherGradeList;
						if(this.gradeList != null) {
							this.gradeList.map((item) => {
								item.childList.map((obj) => {
									obj.isClickSecond = false;
								})
							})
						}
						this.afterArry = [];
						//if(result.data.teacherGradeList != null) {
							for(let i=0;i<this.gradeList.length;i++) {
								for(let c=0;c<this.gradeList[i].childList.length;c++) {
									for(let ic=0;ic<this.gradeList[i].childList[c].childList.length;ic++) {
										let selfDp = '',
												teacherDp = '';
										if(this.gradeList[i].childList[c].childList[ic].checked) {
											selfDp = this.gradeList[i].childList[c].childList[ic].name;
											//for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
												//if(this.teacherGradeList[i].childList[c].childList[j].checked) {
													//teacherDp = this.gradeList[i].childList[c].childList[j].name;
													//break;
												//}
											//}
											let tempObj = {
												'parentname': this.gradeList[i].name,
												'name': this.gradeList[i].childList[c].name,
												'score': this.gradeList[i].childList[c].gradeScore,
												'selfDp': selfDp,
												'teacherDp': teacherDp,
												'description': this.gradeList[i].childList[c].childList[ic].description,
												'teacherScore': null//this.teacherGradeList[i].childList[c].gradeScore
											}
											this.afterArry.push(tempObj);
											break;
										}
									}
								}
							}
							this.getSpanArr(this.afterArry);
						//}
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//点击二级菜单
			clickSecond(index, key) {
				this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
				this.keyData+=1;
			},
			//提交评分
			saveScore() {
				let choiceRuleIds = [];
						
				for(let i=0;i<this.gradeList.length;i++) {
					for(let j=0;j<this.gradeList[i].childList.length;j++) {
						if(!this.gradeList[i].childList[j].checked) {
							this.$alert('练习点评为必选');
							return false;
							break;
						}else {
							choiceRuleIds.push(this.gradeList[i].childList[j].checked);
						}
					}
				}

				let data = {
					'id': this.id,
					'callId': this.callId,
					'choiceRuleIds': choiceRuleIds
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/savePartnerGrade', data).then(response=>{
					var result = response.data;
					console.log(result,9999)
					if(result.success) {
						this.$alert('保存成功');
						this.queryGrade();
						this.selfassessment=true
						this.uploadqueryGrade(result.data)
                        this.complete='yes'
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			getSpanArr(data) {
				this.spanArr = [];
				this.pos = 0;
				for (var i = 0; i < data.length; i++) {
					if(i === 0) {
						// 如果是第一条记录（即索引是0的时候），向数组中加入１
						this.spanArr.push(1);
						this.pos = 0;
					}else {
						if(data[i].parentname=== data[i - 1].parentname) {
							// 如果name相等就累加，并且push 0 （这里的判断视自己的判定依据改变,name就是要对比的字段）
							this.spanArr[this.pos] += 1;
							this.spanArr.push(0);
						}else {
							// 不相等push 1
							this.spanArr.push(1);
							this.pos = i;
						}
					}
				}
			},
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
				// 用于设置要合并的列 0 表示第一列
				if (columnIndex === 0) {
					const cRow = this.spanArr[rowIndex];
					const cCol = cRow > 0 ? 1 : 0;
					return {
						rowspan: cRow, // 合并的行数
						colspan: cCol // 合并的列数，为0表示不显示
					}
				}
			},
			addClass({row,column,rowIndex,columnIndex}) {
	      if(columnIndex == 2 || columnIndex == 3) {
	        return 'self';
	      }
	      if(columnIndex == 4 || columnIndex == 5) {
	        return 'teacher';
	      }
	    }
		}
	}
</script>
<style scoped>
.ivideo{    background-color: #252733;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    align-items: center;}
.ivideo>span{color: #fff;
    width: 80px;}
	.topicformat{display:flex;justify-content: left;
	border-bottom: 10px solid #fff;padding: 10px 0;}
	.SpecialSymbol{width: 23%;display: inline-block;}
	.SpecialSymboltext{width: 70%;}
	.SpecialSymbol>span{color: red;}
	.otherbox{padding: 10px 0 !important}
	.text-style{text-overflow: ellipsis;
	white-space: nowrap;}
</style>


// WEBPACK FOOTER //
// ./src/page/voiceScene/partner.vue